<template functional>
    <label
            ref = "data.ref"
            :class = "[data.class, data.staticClass]"
            :style = "[data.style, data.staticStyle]"
            v-bind = "data.attrs"
            v-on = "listeners"
            class = 'base-label block text-sm leading-5 text-gray-700 font-semibold' >
        <slot/>
    </label>
</template>

<script>
    export default {
        name: "BaseLabel",
    }
</script>